// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__3w1By","consentsList":"PatientConsents_consentsList__yHa6_","consentsListEmpty":"PatientConsents_consentsListEmpty__1oICy"};